import api from "../../domain/api";
import {
  GET_REVIEWSTATUSS_STATED,
  GET_REVIEWSTATUSS,
  GET_REVIEWSTATUSS_ENDED,
  ADD_REVIEWSTATUS_STATED,
  ADD_REVIEWSTATUS,
  ADD_REVIEWSTATUS_ENDED,
  EDIT_REVIEWSTATUS_STATED,
  EDIT_REVIEWSTATUS,
  EDIT_REVIEWSTATUS_ENDED,
  GET_REVIEWSTATUS_STATED,
  GET_REVIEWSTATUS,
  GET_REVIEWSTATUS_ENDED,
  GET_ALL_REVIEWSTATUSS_STATED,
  GET_ALL_REVIEWSTATUSS,
  GET_ALL_REVIEWSTATUSS_ENDED,
} from "../types/reviewstatus_type";
import * as qs from "qs";
import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";

export const addReviewstatus = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADD_REVIEWSTATUS_STATED,
    });
    const { data } = await api.post(`/reviewstatuss`, formData);
    dispatch({
      type: ADD_REVIEWSTATUS,
      payload: data,
    });
    dispatch({
      type: ADD_REVIEWSTATUS_ENDED,
    });
  } catch (error) {
    dispatch({
      type: ADD_REVIEWSTATUS_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getReviewstatuss =
  ({ pageNumber = ""}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_REVIEWSTATUSS_STATED,
      });
      const queryParams = qs.parse(window.location.search.replace("?", ""));
      const query = qs.stringify(queryParams, {
        encodeValuesOnly: true, // prettify url
      });

      const { data } = await api.get(
        `/reviewstatuss?&pageNumber=${pageNumber}&${query}`
      );

      dispatch({
        type: GET_REVIEWSTATUSS,
        payload: data,
      });
      dispatch({
        type: GET_REVIEWSTATUSS_ENDED,
      });
    } catch (error) {
      dispatch({
        type: GET_REVIEWSTATUSS_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getReviewstatus = (id) => async (dispatch) => {
  try {
    dispatch({
      type: GET_REVIEWSTATUS_STATED,
    });
    const { data } = await api.get(`/reviewstatuss/${id}`);

    dispatch({
      type: GET_REVIEWSTATUS,
      payload: data,
    });
    dispatch({
      type: GET_REVIEWSTATUS_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_REVIEWSTATUS_STATED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editReviewstatus = (id, formData) => async (dispatch) => {
  try {
    dispatch({
      type: EDIT_REVIEWSTATUS_STATED,
    });
    const { data } = await api.put(`/reviewstatuss/${id}`, formData);
    dispatch({
      type: EDIT_REVIEWSTATUS,
      payload: data,
    });
    dispatch({
      type: EDIT_REVIEWSTATUS_ENDED,
    });
  } catch (error) {
    dispatch({
      type: EDIT_REVIEWSTATUS_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteReviewstatus = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/reviewstatuss/${id}`);
    dispatch(setAlert("Reviewstatus Deleted Successfully", "success"));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllReviewstatuss = ({ term, value }) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ALL_REVIEWSTATUSS_STATED,
    });
    const { data } = await api.get(`/reviewstatuss/all?term=${term}&value=${value}`);

    dispatch({
      type: GET_ALL_REVIEWSTATUSS,
      payload: data,
    });
    dispatch({
      type: GET_ALL_REVIEWSTATUSS_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_REVIEWSTATUSS_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};

export const handleErrorLocal = () => async (dispatch) => {};
